import { render, staticRenderFns } from "./BridgeProperties.vue?vue&type=template&id=5d70a143&scoped=true&"
import script from "./BridgeProperties.vue?vue&type=script&lang=js&"
export * from "./BridgeProperties.vue?vue&type=script&lang=js&"
import style0 from "./BridgeProperties.vue?vue&type=style&index=0&id=5d70a143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d70a143",
  null
  
)

export default component.exports